import styled from 'styled-components';

const lightenHex = (hex, factor = 0.2) => {
  if (!hex || !hex.startsWith('#') || hex.length < 7) return '#333';
  // Parse the hex string.
  let r = parseInt(hex.substring(1, 3), 16);
  let g = parseInt(hex.substring(3, 5), 16);
  let b = parseInt(hex.substring(5, 7), 16);

  // Increase each channel toward 255 by 'factor'.
  r = Math.round(r + (255 - r) * factor);
  g = Math.round(g + (255 - g) * factor);
  b = Math.round(b + (255 - b) * factor);

  // Convert back to a valid hex string.
  const newHex = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')
    }${b.toString(16).padStart(2, '0')}`;

  return newHex;
};

const getShadowStyle = (theme) => {
  if (!theme?.shadow_color) {
    return '0 4px 8px rgba(0, 0, 0, 0.1)';
  }
  const hexToRgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };
  const softShadowColor = hexToRgba(theme.shadow_color, 0.1);
  return `0 4px 8px ${softShadowColor}`;
};

const getBorderRadius = (theme) => {
  if (theme?.card_style?.includes('slightly-rounded')) return '7px';
  if (theme?.card_style?.includes('squared')) return '0';
  return '15px'; // default rounding
};

export const TitleSubtitleWrapper = styled.div`
  .imagecard-title {
    font-size: 1.5rem;
    color: ${({ theme }) => theme?.card_text_color || '#000'};
  }

  .imagecard-subtitle {
    font-size: .80rem;
    margin-bottom: 15px;
    color: ${({ theme }) => theme?.card_text_color
      ? lightenHex(theme.card_text_color, 0.3) // lighten by ~30%
      : '#333'};
    }
  }
`;

export const ImageScrollContainer = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  margin-bottom: 20px;
  padding-bottom: 10px; /* space for scrollbar if needed */

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }

  .image-item {
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: ${({ theme }) => getShadowStyle(theme)};
    border-radius: ${({ theme }) => getBorderRadius(theme)};
    border: ${({ theme }) =>
    theme?.card_style?.includes('outline')
      ? `2px solid ${theme?.card_color || '#000'}`
      : 'none'};
    position: relative;
    background-color: ${({ theme }) => theme?.background_color || '#f5f5f5'};
    overflow: hidden;

    /* For a fixed height while keeping 4:5 aspect ratio: */
    width: 240px;
    aspect-ratio: 4 / 5;
  }

  img {
    height: 100%;
    object-fit: cover;
    border-radius: ${({ theme }) => getBorderRadius(theme)};
    display: block;
  }

   /* Style for the short title text below the image */
  .image-item-title {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme?.card_text_color || '#333'};
    text-align: center; /* or left, or whatever you prefer */
  }
`;

